/* global Backbone, _ */

'use strict';

var Backbone        = require('backbone');
var _               = require('lodash');

module.exports = Backbone.Model.extend({

    apiUrl: 'https://tailor-dev.telescope.tv/1.0/jobs/',

    defaults: {
    },

    //4c6f53ab-c4a9-462c-8bf3-8b32cad21d21
    /**
     * Initialize
     * @param  {Object} attributes [description]
     * @param  {Object} options    [description]
     */
    initialize: function(attributes, options) {
      this.auth_token = options.auth_token;
      this.job_id = options.job_id;
      if(options.apiUrl && options.apiUrl!==''){
        this.apiUrl = options.apiUrl;
      }
    },

    /**
     * Return URL root
     * @return {String} [description]
     */
    urlRoot: function() {
      //Tailor currently only supports one upload right now, so upload_num is hardcoded to 1.
      return this.apiUrl + '/' + this.job_id + '/start?Authorization=' + this.auth_token;
    },

    /**
     * Save
     * @param  {Object} attributes [description]
     * @param  {Object} options    [description]
     * @return {[type]}            [description]
     */
    save: function(attributes, options) {
      if(typeof this.auth_token === 'undefined' || this.auth_token === null) {
        console.warn('Tailor API requires an authentication token.');
        return;
      }

      if (!Backbone.$.support.cors && window.XDomainRequest) {
        //this.apiUrl = this.altUrl;
        this.trigger('unsupported_browser', this);
        console.warn('Browser does not support cross-domain File upload.');
        return;
      }

      options = {
        type: 'POST',
        dataType: 'json'
      }

      return Backbone.Model.prototype.save.call(this, attributes, options);
    }
});
